module.exports = __webpack_public_path__ + "img/sec-7_icon-ekg.5c4eb643.svg";